var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2636a298f696dc138357ebf725f16a1b023d662c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["modsen@modsen-0n"]={id:"2636a298f696dc138357ebf725f16a1b023d662c"};
      